<template>
  <svg version="1.1"
       id="facebook"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       :width="width"
       :height="height"

       viewBox="0 0 1298 2500"
       style="enable-background:new 0 0 1298 2500;"
       xml:space="preserve"
  >
    <a href="https://www.facebook.com/impactimagingllc/" target="_blank">
      <path class="st0" d="M842.5,2499.7V1359.6h382.7l57.3-444.3h-440V631.6c0-128.6,35.7-216.3,220.2-216.3l235.3-0.1V17.8 c-40.7-5.4-180.4-17.5-342.8-17.5c-339.2,0-571.5,207.1-571.5,587.3v327.7H0v444.3h383.7v1140.1L842.5,2499.7L842.5,2499.7z"/>
    </a>
</svg>
</template>

<script>
export default {
  name: "facebook",
  props: {
    width: String,
    height: String,
  }
}
</script>

<style lang="scss">
  .st0 {
    fill:#FFFFFF;
  }
</style>